const styles = theme => ({
  footer: {
    display: 'flex',
    flexFlow: 'column wrap',
    backgroundColor: '#FFFFFF !important'
  },
  customWidget: {
    marginLeft: '-20%'
  },

  menu: {
    fontFamily: 'Univia Pro',
    fontWeight: '300',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: '1.25',
    letterSpacing: 'normal',
    color: '#3d5065',
    '& h4': {
      fontSize: '18px',
      color: '#3A3A3A !important',
      fontWeight: '600',
      marginBottom: '15px'
    },
    '& ul li a': {
      fontSize: '16px',
      color: '#778493 !important'
    }
  },
  link: {
    display: 'flex',
    flexFlow: 'column wrap',
    width: '50%'
  },
  companyname: {
    marginTop: '20px',
    fontSize: '13px',
    color: '#3A3A3A'
  },
  footerlist: {
    fontSize: '14px',
    '& li': {
      padding: '15px 0px',
      '& a': {
        padding: '0px',
        color: '#676767',
        fontSize: '13px',
        fontWeight: '100'
      }
    }
  }
});

export default styles;

